module.exports = __webpack_public_path__ + "static/img/plat_02.e25b9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/internetPlat/plat_02.jpg
// module id = SFrU
// module chunks = 1